export default "__VITE_ASSET__BIh06IW___"